import { render, staticRenderFns } from "./Pinwheel.vue?vue&type=template&id=0ea7bbee&"
import script from "./Pinwheel.vue?vue&type=script&lang=js&"
export * from "./Pinwheel.vue?vue&type=script&lang=js&"
import style0 from "./Pinwheel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Pinwheel.vue"
export default component.exports